const usePickleballRatingProps = (profileData) => {
    // check for rating to be greater than 0 and display exists
    const hasSinglesRating = !!parseFloat(profileData?.singlesPkbRatingDisplay?.pkbRating);
    const hasDoublesRating = !!parseFloat(profileData?.doublesPkbRatingDisplay?.pkbRating);
    const hasEstimatedRange = profileData?.utrRange?.pkbRating && profileData?.utrRange?.pkbRatingDisplay;

    return {
        hasSinglesRating,
        hasDoublesRating,
        hasEstimatedRange,
    };
};

export default usePickleballRatingProps;
